import React, { useEffect } from "react";

const TooltipPopover = ({ children, className }) => {


    return (
        <div className={`custom-tooltip ${className ? className : ''}`}>
           {children}
        </div>
    );
};

export default TooltipPopover;
